import React, { CSSProperties, FC, ReactNode, RefObject, useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import ReactDOM from 'react-dom';
import gsap from 'gsap';

import useContainerWatch from '../utils/useContainerWatch';
import { getPosition, useClientRect } from '../utils';
import styles from './index.module.less';

interface TipContentProps {
	children: ReactNode;
	triggerEleRef: RefObject<HTMLElement>;
	placement: 'top' | 'right';
	delayMs?: number; // 延迟显示时间
	classNames?: string;
	style?: CSSProperties;
	[key: string]: any;
}

export const TipContent: FC<TipContentProps> = (props) => {
	const {
		children,
		expand,
		triggerEleRef,
		placement = 'top',
		delayMs = 400,
		classNames = '',
		style = {},
		...rest
	} = props;

	const [renderNum, forceRender] = useState(0);
	const tipRef = useRef<HTMLDivElement>(null);

	const triggerRect = useClientRect(triggerEleRef, [renderNum]);
	const tipContentRect = useClientRect(tipRef, [renderNum, children]);

	const { left, top } = getPosition(triggerRect, tipContentRect, placement);

	const handleTipRerender = () => {
		forceRender((c) => c + 1);
	};

	useEffect(() => {
		if (tipRef.current) {
			gsap.to(tipRef.current, {
				delay: delayMs / 1000,
				opacity: 1,
				duration: 0.4,
				ease: 'cubic-bezier(0,0, 0.24, 0.91)',
			});
			return () => {
				gsap.to(tipRef.current, {
					opacity: 0,
					duration: 0.3,
					ease: 'cubic-bezier(0,0, 0.24, 0.91)',
				});
			};
		}
	}, []);

	useContainerWatch(expand, handleTipRerender, triggerEleRef.current, tipRef.current);

	return ReactDOM.createPortal(
		<div
			className={cn({
				[styles.tipWrapper]: true,
				[classNames]: !!classNames,
			})}
			ref={tipRef}
			style={{
				left: `${left}px`,
				top: `${top}px`,
				...style,
			}}
			{...rest}
		>
			{children}
		</div>,
		document.body,
	);
};
